import React from "react";

const InsuranceProtectStats = ({ total, paid, notPaid, totalBilled }) => {
  return (
    <div className="ip-stats-row">
      <div className="ip-stat-card">
        <div className="ip-stat-label">Total Insurances</div>
        <div className="ip-stat-value">{total}</div>
      </div>
      <div className="ip-stat-card">
        <div className="ip-stat-label">Paid</div>
        <div className="ip-stat-value">{paid}</div>
      </div>
      <div className="ip-stat-card">
        <div className="ip-stat-label">Not Paid</div>
        <div className="ip-stat-value ip-stat-value-warning">{notPaid}</div>
      </div>
      <div className="ip-stat-card">
        <div className="ip-stat-label">Total Billed</div>
        <div className="ip-stat-value">
          &euro; {Number(totalBilled || 0).toLocaleString()}
        </div>
      </div>
    </div>
  );
};

export default InsuranceProtectStats;
